import { Injectable } from "@angular/core";
import { CreateBookingWS } from "@app/core/booking/data/network/create-booking.ws";
import { BookingRepo } from "@app/core/booking/domain/booking-repo";
import { Booking } from "@app/core/booking/domain/model/booking";
import { ShareMessageRepo } from "@app/core/share-message/domain/share-message.repo";
import { ShareMessageCapacitor } from "@app/core/share-message/infrastructure/capacitor/share-message.capacitor";
import { WhatsappRepo } from "@app/core/whatsapp/domain/whatsapp.repo";
import { SendWhatsappMessageAllPlatforms } from "@app/core/whatsapp/infrastucture/send-whatsapp-message.all-platforms";

import { Observable, of } from "rxjs";

@Injectable()
export class WhatsappImplRepo implements WhatsappRepo {
  constructor(
    private sendWhatsappMessageAllPlatforms: SendWhatsappMessageAllPlatforms
  ) {}

  sendMessage(message: string, phoneNumber: string): Observable<string> {
    return this.sendWhatsappMessageAllPlatforms.execute(message, phoneNumber);
  }
}
